"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationListSelector = exports.useLocationReportSelector = exports.useLocationsByOrgSelector = exports.useLocationsBySpecialtiesSelector = exports.useLocationDetailsSelector = exports.useLocationSelector = exports.useLocationListSelector = void 0;

var _index = require("../index");

var _toolkit = require("@reduxjs/toolkit");

var _lodash = _interopRequireDefault(require("lodash"));

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var locationMapSelector = function locationMapSelector(state) {
  return state.locationManager.locationMap;
};
/**
 * Returns the data necessary to render the locationManager list
 */


var useLocationListSelector = function useLocationListSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var locations = _ref.locationManager;
    var locationList = locations.locationIds ? locations.locationIds.map(function (id) {
      return locations.locationMap[id];
    }) : null;
    return _objectSpread(_objectSpread({}, _lodash.default.pick(locations, ["loading", "locationIds", "error", "filteredIds"])), {}, {
      numLocations: locationList ? locationList.length : 0,
      locationList: locationList
    });
  });
};
/**
 * Return a single Location record
 * @param locationId    id of the location to return
 */


exports.useLocationListSelector = useLocationListSelector;

var useLocationSelector = function useLocationSelector(locationId) {
  return (0, _index.useShallowEqualSelector)(function (_ref2) {
    var locations = _ref2.locationManager;
    return locations.locationMap[locationId] ? locations.locationMap[locationId] : null;
  });
};
/**
 * Return the data necessary to render the location Details
 * @param locationId    id of the location to return
 */


exports.useLocationSelector = useLocationSelector;

var useLocationDetailsSelector = function useLocationDetailsSelector(locationId) {
  return (0, _index.useShallowEqualSelector)(function (_ref3) {
    var _ref3$locationManager = _ref3.locationManager,
        locationMap = _ref3$locationManager.locationMap,
        locationLoading = _ref3$locationManager.locationLoading,
        locationError = _ref3$locationManager.locationError;
    var location = locationMap[locationId]; // Hack to make sure we get a 'blank' customer to start with when we're adding a customer

    if (locationId && locationId.toLowerCase() === "add") {
      location = {};
    }

    return {
      location: location,
      locationLoading: locationLoading,
      locationError: locationError
    };
  });
};

exports.useLocationDetailsSelector = useLocationDetailsSelector;

var useLocationsBySpecialtiesSelector = function useLocationsBySpecialtiesSelector() {
  var specialtyIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _index.useShallowEqualSelector)(function (_ref4) {
    var _ref4$locationManager = _ref4.locationManager,
        locationIds = _ref4$locationManager.locationIds,
        locationMap = _ref4$locationManager.locationMap;
    return locationIds && locationIds.map(function (locationId) {
      var location = locationMap[locationId];
      var specialties = location.attributes && location.attributes[_attributeIds.default.practiceSpecialty];

      var medications = _attributeIds.default.medicationGroups.map(function (groupId) {
        return location.attributes && location.attributes[groupId] ? location.attributes[groupId].choice : [];
      }).reduce(function (ret, item) {
        return ret.concat(item);
      }, []);

      return _objectSpread({
        lat: location.latitude,
        lng: location.longitude,
        claimed: !!location.orgId,
        email: location.emailAddress,
        specialties: specialties,
        medications: medications
      }, location);
    }).filter(function (location) {
      var result = true;
      specialtyIds.forEach(function (specialtyId) {
        if (location.specialties && location.specialties.choice && location.specialties.choice.indexOf(specialtyId) === -1) {
          result = false;
        }
      });
      return result;
    });
  });
};

exports.useLocationsBySpecialtiesSelector = useLocationsBySpecialtiesSelector;

var useLocationsByOrgSelector = function useLocationsByOrgSelector(orgIds) {
  return (0, _index.useShallowEqualSelector)(function (_ref5) {
    var _ref5$locationManager = _ref5.locationManager,
        locationIds = _ref5$locationManager.locationIds,
        locationMap = _ref5$locationManager.locationMap;
    return locationIds && locationIds.map(function (locationId) {
      return locationMap[locationId];
    }).filter(function (location) {
      return orgIds.includes(location.orgId);
    });
  });
};

exports.useLocationsByOrgSelector = useLocationsByOrgSelector;

var useLocationReportSelector = function useLocationReportSelector(locationId) {
  return (0, _index.useShallowEqualSelector)(function (_ref6) {
    var _ref6$locationManager = _ref6.locationManager,
        reportMap = _ref6$locationManager.reportMap,
        locationReportLoading = _ref6$locationManager.locationReportLoading;
    return {
      report: reportMap && reportMap[locationId] || null,
      locationReportLoading: locationReportLoading
    };
  });
};

exports.useLocationReportSelector = useLocationReportSelector;
var locationListSelector = (0, _toolkit.createSelector)(locationMapSelector, function (locationMap) {
  return Object.values(locationMap);
});
exports.locationListSelector = locationListSelector;